import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7 3h4c2.761 0 5 2.239 5 5s-2.239 5-5 5H9v4l-5-5h.027C2.64 10.612 2 9.643 2 8c0-2.761 2.239-5 5-5z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 14.9998c3.825 0 6.939-3.084 6.995-6.896 2.275.469 3.985 2.483 3.985 4.896 0 1.745-.895 2.816-2.251 4.172l-4.729 4.728v-3.9h-3c-.342 0-.677-.035-1-.101v-2.899z",
    fill: "currentColor"
  }));
});